import Item from '../../models/Item';
import IStateAdjustment from './IStateAdjustment';
class StateController {
  updateStateWithItemElementState(item: Item, state: JSON): void {
    const stateCopy: JSON = JSON.parse(JSON.stringify(state));

    const combined = Object.assign({}, JSON.parse(item.state ? item.state : '{}'), state ? state : {});

    stateCopy['time'] = combined['time'];
    item.state = JSON.stringify(stateCopy);
  }

  static adjustState(json: JSON, adjustmentStrategy: IStateAdjustment): JSON {
    if (json) {
      adjustmentStrategy.adjustState(json);
    }
    return json;
  }
}

export default StateController;
